import React from "react";
import PropTypes from "prop-types";
import {AButton, ADotLoader, ATriggerTooltip} from "@cisco-sbg-ui/magna-react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {selectLoadingExecutionForCoa} from "store/selectors";
import {
  selectEntitiesByType,
  selectEntitiesByTypeLoading
} from "store/selectors/incidentOverviewSelectors";
import {getWorkflowEntityData, isAssetDevice} from "./responseUtils";

export default function SelectEntityButton({
  coa,
  openDrawer,
  setCoaId,
  setCoaTargetType,
  setWorkflowId,
  ...rest
}) {
  const {t} = useTranslation();
  const entitiesByType = useSelector(selectEntitiesByType);
  const isLoadingEntities = useSelector(selectEntitiesByTypeLoading);
  const loadingCoa = useSelector(selectLoadingExecutionForCoa);
  const {id, external_references, open_c2_coa} = coa;
  const externalId = external_references?.[0]?.external_id;
  const coaEntityType = open_c2_coa?.target?.type;

  const data = getWorkflowEntityData(entitiesByType, coaEntityType);
  const disabled = !data?.length || data?.length === 0;
  const isLoading = isLoadingEntities || loadingCoa === id;

  const handleClick = (e) => {
    e.stopPropagation();
    setCoaTargetType(coaEntityType);
    setCoaId(id);
    setWorkflowId(externalId);
    openDrawer();
  };

  const tooltipText = isAssetDevice(coaEntityType)
    ? t("response.doesNotContainDevice")
    : t("response.doesNotContainObservable", {
        type:
          coaEntityType === "domain"
            ? coaEntityType
            : coaEntityType.toUpperCase()
      });

  return isLoading ? (
    <ADotLoader className="ma-0" />
  ) : (
    <ATriggerTooltip
      placement="top"
      content={tooltipText}
      disabled={!disabled}
      wrapChildren>
      <AButton
        {...rest}
        secondary
        small
        disabled={disabled}
        onClick={(e) => handleClick(e)}>
        {t("misc.select")}
      </AButton>
    </ATriggerTooltip>
  );
}

SelectEntityButton.propTypes = {
  /**
   * COA data object
   */
  coa: PropTypes.object,
  /**
   * Function to open the drawer
   */
  openDrawer: PropTypes.func,
  /**
   * Function to set state for current COA ID
   */
  setCoaId: PropTypes.func,
  /**
   * Function to set state of current COA target type
   */
  setCoaTargetType: PropTypes.func,
  /**
   * Function to set state of current workflow ID (external_id)
   */
  setWorkflowId: PropTypes.func
};
